import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { unwrappedNavigationCompetitionIdAtom } from '@/atoms/navigation';
import { LEAGUE_BASE_ROUTE } from '@/utils/classicLinks';

export const useLeagueNavigationItems = () => {
  const { t } = useTranslation('navigation');
  const iqLeagueId = useAtomValue(unwrappedNavigationCompetitionIdAtom);
  const leagueRoute = `${LEAGUE_BASE_ROUTE}/${iqLeagueId}`;

  return [
    {
      id: 'league-table',
      label: t('crossPlatform.secondary.table'),
      route: `${leagueRoute}/league-table`,
    },
    {
      id: 'fixtures',
      label: t('crossPlatform.secondary.fixtures'),
      route: `${leagueRoute}/fixtures`,
    },
    {
      id: 'team-stats',
      label: t('crossPlatform.secondary.teamStats'),
      route: `${leagueRoute}/team-stats`,
    },
    {
      id: 'team-comparison',
      label: t('crossPlatform.secondary.teamComparison'),
      route: `${leagueRoute}/team-comparison`,
    },
    {
      id: 'player-stats',
      label: t('crossPlatform.secondary.playerStats'),
      route: `${leagueRoute}/player-stats`,
    },
  ];
};
